import React, { useEffect, useState } from "react";
import { Button, Popconfirm, Table, Form, Radio, Modal } from "antd";
import { ApplicantSectionsService } from "@frontend/src/core/services/applicant_sections_service";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { openNotificationWithIcon } from "@frontend/src/utilities/notificationWithIcon";
import { UnlockTwoTone, LockTwoTone } from "@ant-design/icons";

// Refactor de portales: Eliminar este archivo  
const ApplicantsSections = ({}) => {
  const actions = (applicant_section) => {
    return (
      <div className="actions">
        <span className="action-box">
          <Button
            type="link"
            className="icon-item"
            size="small"
            onClick={() => {
              setSectionSelected(applicant_section);
              setShowModal(true);
            }}
          >
            <EditOutlined />
          </Button>
        </span>
      </div>
    );
  };

  const [applicantSection, setApplicantSection] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [sectionSelected, setSectionSelected] = useState(null);
  const [allowPublic,setAllowPublic] = useState(false)
  const applicantSectionsService= new ApplicantSectionsService();

  const columnList = [
    {
      title: "Nombre",
      dataIndex: "name",
      render: (text,record) => showLock(text, record)
    },
    {
      dataIndex: "",
      align: "center",
      width: 90,
      fixed: "right",
      render: (record) => actions(record),
    },
  ];

  useEffect(() => {
    fetchReasons();
  }, []);

  function fetchReasons() {
    applicantSectionsService.getApplicantSections(
      (data) => {
        setApplicantSection(data)
      },
      (err) => {}
    );
  }

  const showLock = (text, record) => {
    return (
        <p>{record.private? <i className="fa fa-lock" aria-hidden="true"></i> : <i className="fa fa-unlock" aria-hidden="true"></i> } {text}</p>
    )
  }

  const updateReason = () => {
    applicantSectionsService.update(
      sectionSelected.id,
      {private: allowPublic},
      (res) => {
        setApplicantSection(
          applicantSection.map((item) =>
            item.id === res.id ? { ...res } : item
          )
        );
        setShowModal(false);
        openNotificationWithIcon(
          "success",
          "Seccion actualizada correctamente",
          ""
        );
      },
      (err) => {}
    );
  };

  const createReason = (values) => {
    closingReasonService.create(
      { closing_reason: values },
      (result) => {
        setApplicantSection([...applicantSection, result]);
        setShowModal(false);
        openNotificationWithIcon("success", "Motivo creado correctamente", "");
      },
      (err) => {}
    );
  };

  const showPrivacyModal = () => {
    return (
        <Modal
            title={"Editar sección del perfil"}
            visible={showModal}
            onCancel={() => setShowModal(false)}
            onOk={() => updateReason()}
            cancelText={"Cancelar"}
            okText={"Guardar"}>
            <Form
                layout={'vertical'}>
                <Form.Item label={"Privacidad"}>
                    <Radio.Group
                      defaultValue={sectionSelected ? sectionSelected.private : false}
                      onChange={(e) => setAllowPublic(e.target.value)}>
                        <Radio.Button value={false}>Público</Radio.Button>
                        <Radio.Button value={true}>Privado</Radio.Button>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Modal>
    )
}

  return (
    <div>
      <div className={"card settings-card"}>
        <div className="card-header">
          <div className="title">Privacidad en secciones del perfil</div>
        </div>
        <div className="card-body">
          <div>
            <Table
              columns={columnList}
              dataSource={applicantSection}
              loading={false}
              pagination={false}
              showSorterTooltip={false}
              scroll={{ y: 200 }}
            />
          </div>
        </div>
      </div>
      {showModal && showPrivacyModal()
      
      }
    </div>
  );
};

export default ApplicantsSections;
